import api from '../../services/serviceBase'

export default {
    getUser(login){
        return api.execute('get', `/User/UserInfo?login=${login}`);
    },
    getUserEngagementScore(login, startDate, endDate) {
        return api.execute('get', `/User/EngagementScoreMetricsSummary?login=${login}&startDate=${startDate}&endDate=${endDate}`);
    },
    getUserLogins(login, startDate, endDate) {
        return api.execute('get', `/User/LoginMetricsSummary?login=${login}&startDate=${startDate}&endDate=${endDate}`);
    },
    getUserColorMyDay(login, startDate, endDate) {
        return api.execute('get', `/User/ColorMyDayMetricsSummary?login=${login}&startDate=${startDate}&endDate=${endDate}`);
    },
    GetActivitiesByUserAndDate(login, practice, startDate, endDate) {
        return api.execute('get', `/User/ActivitiesSeries?email=${login}&practiceCode=${practice}&startDate=${startDate}&endDate=${endDate}`);
    },
    getUserNutritionSummary(login, startDate, endDate) {
        return api.execute('get', `/User/NutritionDaysLoggedMetricsSummary?login=${login}&startDate=${startDate}&endDate=${endDate}`);
    },
    Authenticate(credentials){
        return api.execute('post', `/Authorization/Authenticate`,credentials); 
    },
    SavePatientInteractionSession(session){
        console.log('USERSERVICES::SAVEPATIENTINTERACITONSCORE::SESSION: ', session)
        return api.execute('post', '/User/PatientInteractionSession', session);
    },
    GetPatientInteractionScore(patientLogin, startDate, endDate){
        return api.execute('get', `/User/PatientInteractionScore?patientLogin=${patientLogin}&startDate=${startDate}&endDate=${endDate}`);
    },
    GetPatientInteractionScoreSeries(patientLogin, startDate, endDate){
        return api.execute('get', `/User/PatientInteractionScoreSeries?patientLogin=${patientLogin}&startDate=${startDate}&endDate=${endDate}`);
    },
    OnboardNewUser(userData) {
        return api.execute('post', `/User/OnboardNewUser`, userData);
    }
}